// Centralized course data — single source of truth
import comboTotalImg from '../images/combo-total-new.png';
import estrategiaModernaImg from '../images/estrategia-moderna.png';
import taticaImg from '../images/tatica.png';
import comoEvoluirImg from '../images/como-evoluir.png';
import zeroProfessorImg from '../images/zero-professor.png';
import estudoEstrategiaImg from '../images/estudo-estrategia.png';
import aberturasLendasImg from '../images/aberturas-lendas.png';
import jogadorPraticoImg from '../images/jogador-pratico.png';
import aberturaBispoImg from '../images/abertura-bispo.png';
import finaisVencedoresImg from '../images/finais-vencedores.png';
import maestriaCalculoImg from '../images/maestria-calculo.png';
import inglesaDinamicaImg from '../images/inglesa-dinamica.png';
import vencaCaroKannImg from '../images/venca-caro-kann.png';
import enfrentarCaroKannImg from '../images/enfrentar-caro-kann.png';
import londonModernaImg from '../images/london-moderna.png';
import indiaDoReiImg from '../images/india-do-rei.png';
import defesaGruenfeldImg from '../images/defesa-gruenfeld.png';
import sicilianaSveshnikovImg from '../images/siciliana-sveshnikov.png';
import petrofDoNepoImg from '../images/petrof-do-nepo.png';
import enfrentarFrancesaImg from '../images/enfrentar-francesa.png';
import cincoSegredosImg from '../images/5-segredos.png';

const CATEGORIES = {
  ABERTURAS: 'Aberturas',
  TATICA: 'Tática',
  ESTRATEGIA: 'Estratégia',
  FINAIS: 'Finais',
  GERAL: 'Geral',
  COMBO: 'Combo',
};

// The 18 individual courses from the Combo Total
export const individualCourses = [
  {
    id: 'do-zero-a-professor',
    name: 'Do Zero a Professor de Xadrez',
    price: 120,
    paymentUrl: 'https://pay.kiwify.com.br/k2KdRC0',
    category: CATEGORIES.GERAL,
    description: 'Aprenda xadrez do nível iniciante até se tornar um professor certificado. Acesso vitalício e certificado de conclusão.',
    instructor: 'GM André Diamant',
    image: zeroProfessorImg,
    route: '/curso/do-zero-a-professor',
    lessons: [
      'Introdução ao Curso',
      'O Tabuleiro de Xadrez e o Movimento das Peças',
      'Roque, En Passant, Xeque e Xeque Mate',
      'Básicos do Xadrez: Movimento das Peças',
      'Básicos do Xadrez: Capturar, Defender, Clouding',
      'Posição Inicial, Roque, En Passant, Rei Afogado',
      'Mates Básicos',
      'Padrões de Xeque Mate',
      'Cravada e Garfo',
      'Espeto e Ataque Descoberto',
      'Xeque Duplo, Peças Sobrecarregadas e Raio-X',
      'Mais Padrões de Xeque Mate',
      'Xeque Mates Desafiadores',
      'Ainda Mais Padrões de Xeque Mate',
      'Xeque Mate de Bispo e Cavalo',
      'Mate com Rei e 2 Cavalos contra Rei e Peão',
      'BÔNUS: Como Estudar e Como Dar Aula',
      'BÔNUS: Como Jogar uma Partida de Xadrez',
    ],
  },
  {
    id: 'como-evoluir',
    name: 'Como Evoluir no Xadrez',
    price: 98,
    paymentUrl: 'https://pay.kiwify.com.br/bafQj2Z',
    category: CATEGORIES.GERAL,
    description: 'Descubra os caminhos para evoluir seu jogo de xadrez de forma consistente e eficaz.',
    instructor: 'GM André Diamant',
    image: comoEvoluirImg,
    route: '/curso/como-evoluir',
    lessons: [
      'Mindset e Plano de Estudos',
      'O Uso Correto da Tecnologia',
      'Como Estudar Tática',
      'Como Estudar Aberturas',
      'Seu Repertório de Aberturas',
      'Como Estudar Estratégia',
      'Como Estudar Finais',
      'Como Analisar suas Partidas',
    ],
  },
  {
    id: 'fortaleca-tatica',
    name: 'Fortaleça sua Tática',
    price: 198,
    paymentUrl: 'https://pay.kiwify.com.br/GHkl3pU',
    category: CATEGORIES.TATICA,
    description: 'Fortaleça suas habilidades táticas com exercícios e padrões ensinados pelo Grande Mestre André Diamant.',
    instructor: 'GM André Diamant',
    image: taticaImg,
    route: '/curso/fortaleca-tatica',
    lessons: [
      'Aula 01',
      'Aula 02',
      'Aula 03',
      'Aula 04',
      'Aula 05',
      'Aula 06',
      'Aula 07',
      'Aula 08',
      'Aula 09',
      'Aula 10',
      'Aula 11',
      'Aula 12',
    ],
  },
  {
    id: 'estudo-estrategia',
    name: 'Estudo de Estratégia: Caminho para ser um Campeão',
    price: 198,
    paymentUrl: 'https://pay.kiwify.com.br/bUvCdNH',
    category: CATEGORIES.ESTRATEGIA,
    description: 'Domine os princípios estratégicos que separam os campeões dos demais jogadores.',
    instructor: 'GM André Diamant',
    image: estudoEstrategiaImg,
    route: '/curso/estudo-estrategia',
    lessons: [
      'Importância da Estratégia / Como Pensar',
      'Erros Típicos de Debilidades e Conceitos',
      'Debilidade da Ala do Rei / Roque Adversário',
      'Astúcia: Explorando as Casas Fracas',
      'Estruturas de Peões',
      'A Importância das Colunas Abertas',
      'Superioridade entre Bispo X Cavalo',
      'Referências em Estratégias / Exemplos',
    ],
  },
  {
    id: 'aberturas-lendas',
    name: 'As Aberturas das Lendas do Xadrez',
    price: 198,
    paymentUrl: 'https://pay.kiwify.com.br/uanM2xg',
    category: CATEGORIES.ABERTURAS,
    description: 'Estude as aberturas utilizadas pelas maiores lendas da história do xadrez.',
    instructor: 'GM André Diamant',
    image: aberturasLendasImg,
    route: '/curso/aberturas-lendas',
    lessons: [
      'Fischer – Karpov (Parte 1)',
      'Fischer – Karpov (Parte 2)',
      'Tal – Carlsen (Parte 1)',
      'Tal – Carlsen (Parte 2)',
      'Anand – Kramnik (Parte 1)',
      'Anand – Kramnik (Parte 2)',
      'Kasparov – Petrosian (Parte 1)',
      'Kasparov – Petrosian (Parte 2)',
    ],
  },
  {
    id: 'jogador-pratico',
    name: 'O Jogador Prático',
    price: 98,
    paymentUrl: 'https://pay.kiwify.com.br/VmUM7mo',
    category: CATEGORIES.GERAL,
    description: 'Aprenda a tomar decisões práticas e eficientes durante suas partidas de xadrez.',
    instructor: 'GM André Diamant',
    image: jogadorPraticoImg,
    route: '/curso/jogador-pratico',
    lessons: [
      'Aula 01',
      'Aula 02',
      'Aula 03',
      'Aula 04',
      'Aula 05',
    ],
  },
  {
    id: 'abertura-bispo',
    name: 'Vença com a Abertura do Bispo',
    price: 98,
    paymentUrl: 'https://pay.kiwify.com.br/1Oiynpe',
    category: CATEGORIES.ABERTURAS,
    description: 'Domine a Abertura do Bispo e surpreenda seus adversários com essa arma poderosa.',
    instructor: 'GM André Diamant',
    image: aberturaBispoImg,
    route: '/curso/abertura-bispo',
    lessons: [
      'Aula 01',
      'Aula 02',
      'Aula 03',
      'Aula 04',
    ],
  },
  {
    id: 'finais-vencedores',
    name: 'Finais Vencedores',
    price: 98,
    paymentUrl: 'https://pay.kiwify.com.br/rvQeTLX',
    category: CATEGORIES.FINAIS,
    description: 'Domine os finais de partida e transforme posições iguais em vitórias.',
    instructor: 'GM André Diamant',
    image: finaisVencedoresImg,
    route: '/curso/finais-vencedores',
    lessons: [
      'Aula 01',
      'Aula 02',
      'Aula 03',
      'Aula 04',
      'Aula 05',
    ],
  },
  {
    id: 'maestria-calculo',
    name: 'Maestria do Cálculo',
    price: 198,
    paymentUrl: 'https://pay.kiwify.com.br/U1S54kg',
    category: CATEGORIES.TATICA,
    description: 'Aprimore sua capacidade de cálculo e visualização no tabuleiro.',
    instructor: 'GM André Diamant',
    image: maestriaCalculoImg,
    route: '/curso/maestria-calculo',
    lessons: [
      'Ataque Yuguslavo X Dragão',
      'Ataque Inglês X Najdorf',
      'Ataque Inglês X Sheveningen',
      'Dragão x Ataque Inglês',
      'Najdorf x Variante do Bg5',
      'Ataques contra a Pirc',
      'Ataque Inglês X Taimanov',
      'Taimanov x Ataque Inglês',
    ],
  },
  {
    id: 'inglesa-dinamica',
    name: 'A Inglesa Dinâmica',
    price: 198,
    paymentUrl: 'https://pay.kiwify.com.br/kicFSsJ',
    category: CATEGORIES.ABERTURAS,
    description: 'Aprenda a jogar a Abertura Inglesa de forma dinâmica e agressiva.',
    instructor: 'GM André Diamant',
    image: inglesaDinamicaImg,
    route: '/curso/inglesa-dinamica',
    lessons: [
      'Linha Principal e5',
      'Fechada',
      'Ortodoxa',
      'Eslava',
      'Grunfeld',
      'Simétrica',
      'Índia do Rei',
      'Revisão Geral e Aprimoramentos',
    ],
  },
  {
    id: 'venca-caro-kann',
    name: 'Vença com a Caro-Kann',
    price: 198,
    paymentUrl: 'https://pay.kiwify.com.br/FGMyrDe',
    category: CATEGORIES.ABERTURAS,
    description: 'Domine a Defesa Caro-Kann e tenha uma arma sólida contra 1.e4.',
    instructor: 'GM André Diamant',
    image: vencaCaroKannImg,
    route: '/curso/venca-caro-kann',
    lessons: [
      'Linha Principal 1',
      'Linha Principal 2',
      'Variante do Avanço 1',
      'Variante do Avanço 2',
      'Fantasy',
      'Dois Cavalos',
      'Panov',
      'Ataque Índio do Rei',
    ],
  },
  {
    id: 'enfrentar-caro-kann-individual',
    name: 'Como Enfrentar a Caro-Kann',
    price: 198,
    paymentUrl: 'https://pay.kiwify.com.br/OLhVl22',
    category: CATEGORIES.ABERTURAS,
    description: 'Aprenda as melhores estratégias para enfrentar a Defesa Caro-Kann com confiança.',
    instructor: 'GM André Diamant',
    image: enfrentarCaroKannImg,
    route: '/curso/enfrentar-caro-kann',
    lessons: [
      'Ideia Principal (Perunovic X Lalith)',
      'Sublinha (Barbosa X Molina)',
      'Aproveitando o Erro das Pretas (Matrovasili)',
      'h6 com Be4 (Popov X Arutnian)',
      'h6 com Bd7 (Shankland X Jobava)',
      'Matando a Linha da Moda 3...c5 (Carlsen)',
    ],
    bonuses: ['PGN dos Estudos'],
  },
  {
    id: 'london-moderna',
    name: 'London Moderna',
    price: 198,
    paymentUrl: 'https://pay.kiwify.com.br/89qv9it',
    category: CATEGORIES.ABERTURAS,
    description: 'Domine o Sistema London moderno, uma abertura sólida e versátil para as brancas.',
    instructor: 'GM André Diamant',
    image: londonModernaImg,
    route: '/curso/london-moderna',
    lessons: [
      'Introdução à London',
      'Como Arrematar as Linhas 1.d4 d5 2.Bf4!',
      'Evitando o Sistema Chigorin',
      'Aprenda a Punir a Índia do Rei',
      'O Juízo Final das Defesas Índias',
      'Repertório Definitivo contra a Grunfeld',
      'Executando as Linhas Anti-Benoni',
      'O Poder da London contra a Holandesa',
    ],
  },
  {
    id: 'india-do-rei',
    name: 'Jogue a Índia do Rei como um Grande Mestre',
    price: 198,
    paymentUrl: 'https://pay.kiwify.com.br/TA0FFoZ',
    category: CATEGORIES.ABERTURAS,
    description: 'Aprenda a jogar a Defesa Índia do Rei no nível de Grande Mestre.',
    instructor: 'GM André Diamant',
    image: indiaDoReiImg,
    route: '/curso/india-do-rei',
    lessons: [
      'Linha Principal',
      'Petrosian',
      'Saemisch',
      'Fianchetto',
      'Averbach',
      'London',
      'Quatro Peões',
      'Variante das Trocas e Outras',
    ],
  },
  {
    id: 'defesa-gruenfeld',
    name: 'Defesa Gruenfeld',
    price: 198,
    paymentUrl: 'https://pay.kiwify.com.br/F4gJ1Tg',
    category: CATEGORIES.ABERTURAS,
    description: 'Estude a Defesa Gruenfeld, uma das aberturas mais dinâmicas do xadrez.',
    instructor: 'GM André Diamant',
    image: defesaGruenfeldImg,
    route: '/curso/defesa-gruenfeld',
    lessons: [
      'Combatendo a Linha Principal',
      'Dando a Volta nas Linhas Bg5',
      'Destruindo os Sistemas com Db3',
      'Avante contra o Bf4!',
      'Enfrentando a Anti-Gruenfeld',
      'Destruindo o Fiancheto',
      'Inglesa não Passa!',
      'Variantes Raras',
    ],
  },
  {
    id: 'siciliana-sveshnikov',
    name: 'A Siciliana Sveshnikov do Carlsen',
    price: 198,
    paymentUrl: 'https://pay.kiwify.com.br/438fPFl',
    category: CATEGORIES.ABERTURAS,
    description: 'Aprenda a variante Sveshnikov da Siciliana, a arma secreta de Magnus Carlsen.',
    instructor: 'GM André Diamant',
    image: sicilianaSveshnikovImg,
    route: '/curso/siciliana-sveshnikov',
    lessons: [
      'Sublinhas',
      'Chelyabinsk',
      'Novosibirsk',
      'Pelikan',
      'Pelikan Cheliabinsky',
      'Cd5 Rápido',
      'Rossolimo',
      'Complemento',
    ],
  },
  {
    id: 'petrof-do-nepo',
    name: 'Petrof do Nepo',
    price: 198,
    paymentUrl: 'https://pay.kiwify.com.br/nO4EnPa',
    category: CATEGORIES.ABERTURAS,
    description: 'Domine a Defesa Petroff, a arma usada por Nepomniachtchi para vencer o Torneio de Candidatos.',
    instructor: 'GM André Diamant',
    image: petrofDoNepoImg,
    route: '/curso/petrof-do-nepo',
    lessons: [
      'Variante Principal (Rapport X Nepo)',
      'Caruana X Nepo e Carlsen X Nepo',
      'Variante Shirov (Fier X Pap)',
      'Variante do Shirov! Teoria',
      'Petrof Escocesa (Duda X Nepo)',
      'Petrof Escocesa (Nepo X Leinier)',
      'Cochrane Gambit',
      'Sublinhas (Firouzja X Nepo)',
      'Sublinhas (Harikrishna X Giri e Anand X Caruana)',
      'Variante dos 3 Cavalos (Nepo X Dominguez)',
      'Duas Partidas Jogando Petrof',
    ],
    bonuses: ['Aula Bônus: Fier X Kuzubov', 'Material para Download'],
  },
  {
    id: 'enfrentar-francesa',
    name: 'Como Enfrentar a Defesa Francesa',
    price: 198,
    paymentUrl: 'https://pay.kiwify.com.br/p6OO6v7',
    category: CATEGORIES.ABERTURAS,
    description: 'Aprenda as melhores estratégias para enfrentar a Defesa Francesa com as brancas.',
    instructor: 'GM André Diamant',
    image: enfrentarFrancesaImg,
    route: '/curso/enfrentar-francesa',
    lessons: [
      'Introdução à Defesa Francesa',
      'Linha Principal (Diamant X Assumpção)',
      'Linha Principal g5 (Diamant X Rendle)',
      'Linha Principal g5 Parte 2 (Diamant X Prasca)',
      'Linha Principal: Sacrifício do Peão',
      'c5 (Carlsen e Adams)',
      'Peão Isolado (Karpov X Uhlmann)',
      'Variante das Trocas (Diamant X Coelho)',
      'Variante das Trocas Parte 2 (Iordachescu X Diot)',
    ],
    bonuses: ["PGN's para Download"],
  },
];

// Existing standalone products (separate from the Combo)
const standaloneCourses = [
  {
    id: 'combo-total',
    name: 'Combo Total',
    price: 299,
    paymentUrl: 'https://pay.kiwify.com.br/gtYBuNj',
    category: CATEGORIES.COMBO,
    description: 'Combo de 18 Cursos em videoaulas com o Grande Mestre André Diamant para você melhorar no xadrez. Aberturas, Cálculo, Táticas e Estratégia.',
    instructor: 'GM André Diamant',
    image: comboTotalImg,
    route: '/combo-total',
    isCombo: true,
    courseCount: 18,
  },
  {
    id: '5-segredos',
    name: '5 Segredos para Melhorar no Xadrez',
    price: 93,
    paymentUrl: 'https://pay.kiwify.com.br/TBjMKxi',
    category: CATEGORIES.GERAL,
    description: 'Descubra os 5 segredos que vão transformar seu jogo com a Mestre Nacional Isabella Conti.',
    instructor: 'MN Isabella Conti',
    image: cincoSegredosImg,
    route: '/5-segredos',
  },
  {
    id: 'estrategia-moderna',
    name: 'Estratégia Moderna do Xadrez',
    price: 120,
    paymentUrl: 'https://pay.kiwify.com.br/tbYqrPP',
    category: CATEGORIES.ESTRATEGIA,
    description: 'Aumente seu entendimento estratégico com "Estratégia Moderna do Xadrez" de Ludek Pachman, em mais de 40 videoaulas.',
    instructor: 'MN Rafael Leite',
    image: estrategiaModernaImg,
    route: '/estrategiamoderna',
    isFeatured: true,
  },
  {
    id: 'enfrentar-caro-kann',
    name: 'Como Enfrentar a Caro-Kann',
    price: 98,
    paymentUrl: 'https://pay.kiwify.com.br/OLhVl22',
    category: CATEGORIES.ABERTURAS,
    description: 'Curso completo sobre como enfrentar a Defesa Caro-Kann com o GM André Diamant.',
    instructor: 'GM André Diamant',
    image: enfrentarCaroKannImg,
    route: '/como-enfrentar-caro-kann',
  },
  {
    id: 'zero-professor',
    name: 'Do Zero a Professor de Xadrez',
    price: 120,
    paymentUrl: 'https://pay.kiwify.com.br/k2KdRC0',
    category: CATEGORIES.GERAL,
    description: 'Aprenda do zero e torne-se um professor de xadrez certificado.',
    instructor: 'GM André Diamant',
    image: zeroProfessorImg,
    route: '/do-zero-a-professor-de-xadrez',
  },
];

// All courses combined
export const allCourses = [...standaloneCourses, ...individualCourses];

// Helper to get combo course
export const comboCourse = standaloneCourses.find(c => c.isCombo);

// Featured courses (Combo + Estratégia Moderna) shown at the top
export const featuredCourses = standaloneCourses.filter(c => c.isCombo || c.isFeatured);

// Helper to get courses for the landing page grid (excludes featured courses)
export const gridCourses = [...individualCourses, ...standaloneCourses.filter(c => !c.isCombo && !c.isFeatured)];

// Get unique categories for filter
export const categories = [
  'Todos',
  CATEGORIES.ABERTURAS,
  CATEGORIES.TATICA,
  CATEGORIES.ESTRATEGIA,
  CATEGORIES.FINAIS,
  CATEGORIES.GERAL,
];

// Find a course by its ID
export function getCourseById(id) {
  return allCourses.find(c => c.id === id);
}

// Find a course by its route
export function getCourseByRoute(route) {
  return allCourses.find(c => c.route === route);
}

export { CATEGORIES };
export default allCourses;
